/* eslint-disable */
import React,{Component} from "react";
import NotificationSystem from 'react-notification-system';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { addNotification } from '../../actions/notificationActions';


class Notification extends Component {
  constructor(props) {
    super(props);
    // this.notificationSystem = React.createRef();
    this.notificationSystem = null;
  }

  componentWillReceiveProps(newProps) {
    const { message, level } = newProps.notification;
    this.notificationSystem.addNotification({
      position: 'tc',
      autoDismiss: 20,
      message,
      level
    });
  }

  componentDidMount() {
    this.notificationSystem = this.refs.notificationSystem;
  }
  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    notification: state.notification
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      addNotification
    }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notification);


